import React from 'react'
import { Container, Row } from 'react-bootstrap'
import Judul from 'components/dashboard/dashcomp/judul'
import CardProduk from 'components/dashboard/dashcomp/card_produk'
import Produk from 'json/toko_reseller/produk'
import './style.css'

export default function produk() {
    return (
        <Container className="toko_reseller_produk">
            <Judul judul="Produk" />
            <p>Total Produk : 9</p>
            <Row>
                {
                    Produk.map((item, i) => {
                        return (
                            <CardProduk key={i}
                            header={item.header}
                            src={`asset/dashboard/produk/${item.src}${i + 1}.png`} 
                            alt="produk"
                            text={item.text} potongan={item.potongan}
                            price={item.price} shere={item.shere}
                            />
                        )
                    })
                }
            </Row>
        </Container>
    )
}
